import type { PlayerState } from "../state/types.js";

export function tickPlayerActions(players: PlayerState[]): void {
  for (const p of players) {
    if (p.action === "Stunned") {
      if (p.stunTicks > 0) p.stunTicks -= 1;
      if (p.stunTicks <= 0) {
        p.action = "Idle";
        p.actionTimer = 0;
      }
    } else if (p.action === "RecoverCheck") {
      if (p.recoveryTicks > 0) p.recoveryTicks -= 1;
      if (p.recoveryTicks <= 0) {
        p.action = "Idle";
        p.actionTimer = 0;
      }
    }
  }
}
